import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Calendar from './pages/Dashboard/Calendar';
import ContactPage from './pages/AITalker/ContactPage';
import FAQ from './pages/Dashboard/FAQ';
import LearnMore from './pages/LearnMore';
import LearnMoreOnboarding from './pages/LearnMore/Onboarding';
import LearnMoreDashboard from './pages/LearnMore/Dashboard/Overview';
import LearnMoreCalendar from './pages/LearnMore/Dashboard/Calendar';
import LearnMoreCallLogs from './pages/LearnMore/Dashboard/CallLogs';
import LearnMoreCallAnalytics from './pages/LearnMore/Dashboard/CallAnalytics';
import LearnMoreDashboardFAQ from './pages/LearnMore/Dashboard/FAQ';
import LearnMoreAITalkerOverview from './pages/LearnMore/AITalker/Overview';
import LearnMoreAITalkerUseCases from './pages/LearnMore/AITalker/UseCases';
import LearnMoreAITalkerConfiguration from './pages/LearnMore/AITalker/Configuration';
import LearnMoreAITalkerPlayground from './pages/LearnMore/AITalker/Playground';
import LearnMoreAITalkerIntegration from './pages/LearnMore/AITalker/Integration';
import LearnMoreProfileSettings from './pages/LearnMore/Settings/ProfileSettings';
import LearnMoreUserManagement from './pages/LearnMore/Settings/UserManagement';
import LearnMoreBillingAndPayment from './pages/LearnMore/Settings/BillingAndPayment';
import LearnMoreSecuritySettings from './pages/LearnMore/Settings/SecuritySettings';
import LearnMoreSettings from './pages/LearnMore/Settings';
import Onboarding from './pages/Onboarding';
import CallLogs from './pages/Dashboard/CallLogs';
import CallAnalytics from './pages/Dashboard/CallAnalytics';
import ProfileSettings from './pages/ProfileSettings';
import BillAndPayment from './pages/BillAndPayment';
import UserManagement from './pages/UserManagement';
import DeploymentManagement from './pages/DeploymentManagement';
import ConversationFlowDefinition from './pages/UseCases/ConversationFlowDefinition';

import Dashboards from './pages/Dashboard/Dashboards';
import OnboardingSummary from './pages/Onboarding/OnboardingSummary';
import OnboardingComplete from './pages/Onboarding/OnboardingComplete';
import Resources from './pages/Resources';
import CustomerManagement from './pages/Resources/CustomerManagement';
import Products from './pages/Resources/Products';
import CreateAgent from './pages/AIAgents/CreateAgent';
import AIAgents from './pages/AIAgents';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardOverview from './pages/Dashboard/DashboardOverview';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ai-agents" element={<ProtectedRoute><AIAgents /></ProtectedRoute>} />
      <Route path="/ai-agents/create" element={<ProtectedRoute><CreateAgent /></ProtectedRoute>} />
      <Route path="/ai-agents/edit/:id" element={<ProtectedRoute><CreateAgent /></ProtectedRoute>} />
      <Route path="/learn-more" element={<LearnMore />}>
        <Route index element={<LearnMoreOnboarding />} />
        <Route path="onboarding" element={<LearnMoreOnboarding />} />
        <Route path="dashboard" element={<LearnMoreDashboard />} />
        <Route path="dashboard/calendar" element={<LearnMoreCalendar />} />
        <Route path="dashboard/call-logs" element={<LearnMoreCallLogs />} />
        <Route path="dashboard/call-analytics" element={<LearnMoreCallAnalytics />} />
        <Route path="dashboard/faq" element={<LearnMoreDashboardFAQ />} />
        <Route path="aitalker" element={<LearnMoreAITalkerOverview />} />
        <Route path="aitalker/use-cases" element={<LearnMoreAITalkerUseCases />} />
        <Route path="aitalker/configuration" element={<LearnMoreAITalkerConfiguration />} />
        <Route path="aitalker/playground" element={<LearnMoreAITalkerPlayground />} />
        <Route path="aitalker/integration" element={<LearnMoreAITalkerIntegration />} />
        <Route path="settings" element={<LearnMoreSettings />} />
        <Route path="settings/profile" element={<LearnMoreProfileSettings />} />
        <Route path="settings/user-management" element={<LearnMoreUserManagement />} />
        <Route path="settings/billing" element={<LearnMoreBillingAndPayment />} />
        <Route path="settings/security" element={<LearnMoreSecuritySettings />} />
      </Route>
      <Route path="/onboarding/*" element={<Onboarding />} />
      <Route path="/payments" element={<OnboardingSummary/>}/> //for demo
      <Route path="/complete" element={<OnboardingComplete/>}/> //for demo
      <Route path="/dashboard" element={<ProtectedRoute><Dashboards /></ProtectedRoute>}>
        <Route index element={<ProtectedRoute><DashboardOverview /></ProtectedRoute>} />
        <Route path="call-logs" element={<ProtectedRoute><CallLogs /></ProtectedRoute>} />
        <Route path="call-analytics" element={<ProtectedRoute><CallAnalytics /></ProtectedRoute>} />
      </Route>
      <Route path="/profile-settings" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />
      <Route path="/bill-and-payment" element={<ProtectedRoute><BillAndPayment /></ProtectedRoute>} />
      <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
      <Route path="/deployment-management" element={<ProtectedRoute><DeploymentManagement /></ProtectedRoute>} />
      <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>}>
        <Route index element={<Navigate to="/resources/calendar" replace />} />
        <Route path="calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
        <Route path="contact" element={<ProtectedRoute><ContactPage /></ProtectedRoute>} />
        <Route path="faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
        <Route path="customers" element={<ProtectedRoute><CustomerManagement /></ProtectedRoute>} />
        <Route path="products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
